import { reducerNames } from 'store/constants';

export const getAccountsState = (state) => state[reducerNames.PROVISION].accounts;